import { useState, useEffect } from "react";
import RTC, { RecordRTCPromisesHandler } from "recordrtc";

export const useRecorderPermission = (): [RecordRTCPromisesHandler | undefined, MediaStream | undefined] => {
    const [recorder, setRecorder] = useState<RecordRTCPromisesHandler>();
    const [stream, setStream] = useState<MediaStream>();

    const getPermissionInitializeRecorder = async (): Promise<void> => {
        const st = await navigator.mediaDevices.getUserMedia({
            audio: true
        });

        setStream(st);

        const rc = new RecordRTCPromisesHandler(st, {
            type: "audio",
            mimeType: "audio/wav",
            recorderType: RTC.StereoAudioRecorder,
            // timeSlice: 1000,
            disableLogs: true,
            // requires timeSlice above
            ondataavailable: function (blob) {},
            // requires timeSlice above
            onTimeStamp: function (timestamp) {},
            // range 22050 to 96000.
            // sampleRate: 96000,
            // the range 22050 to 96000.
            desiredSampRate: 16000,
            // Legal values are (256, 512, 1024, 2048, 4096, 8192, 16384).
            bufferSize: 16384,
            numberOfAudioChannels: 1
        });

        setRecorder(rc);
    };

    useEffect(() => {
        void getPermissionInitializeRecorder();
    }, []);

    return [recorder, stream];
};
